<template>
  <HeroSection 
    title="Découvrez toutes les fonctionnalités"
    subtitle="Un outil complet, pensé pour les PME et les équipes qui veulent aller à l'essentiel."
    :isBig="false"
    bgImg="functionalities.jpg"
  />

  <!-- Détail des modules -->
  <section class="py-16 bg-white">
    <div class="max-w-5xl mx-auto flex flex-col gap-16">
      <!-- Planning -->
      <FeatureBlock
        title="Le planning"
        description="Nailit propose un planning horizontal permettant de visualiser l’ensemble des projets et tâches sur une ligne du temps, avec les ressources humaines affichées en colonne. Cette organisation offre une vue immédiate sur les disponibilités de chacun et facilite la planification. La création de tâches se fait simplement par glisser-déposer sur le planning."
        
        img="planning.png"
        :imgLeft="true"
        :imgWidth="500"
      />

      <!-- Gestion de projets -->
      <FeatureBlock
        title="Les projets"
        description="Avec Nailit, la gestion de projet est simplifiée et évolutive. Créez et gérez facilement des centaines de projets, assignez-les à vos ressources humaines et suivez leur avancement en temps réel grâce à un planning et une trésorerie dédiés."
        img="projet.png"
        :imgLeft="false"
        :imgWidth="500"
      />

      <!-- Trésorerie -->
      <FeatureBlock
        title="La trésorerie"
        description="Notre module de trésorerie vous permet de suivre en temps réel vos dépenses et vos recettes, avec une visibilité sur plusieurs mois à l'avance. Anticipez les périodes sensibles, identifiez rapidement les besoins de trésorerie et déterminez le meilleur moment pour accepter de nouveaux clients. Bénéficiez d'indicateurs clairs pour piloter sereinement la santé financière de votre activité."
        img="treso.png"
        :imgLeft="true"
        :imgWidth="400"
      />

      <!-- Ressources -->
      <FeatureBlock
        title="Les ressources humaines"
        description="Gérez facilement vos ressources humaines avec Nailit. Ajoutez des collaborateurs en renseignant leurs informations essentielles (nom, rôle, coordonnées, etc.) et regroupez-les par équipe pour une organisation optimale."
        img="ressources.png"
        :imgLeft="false"
        :imgWidth="500"
      />

      <!-- Boîte à idées -->
      <FeatureBlock
        title="La boîte à idées"
        description="Enregistrez toutes vos idées de futurs projets ou tâches dans une boîte à idées centralisée. Classez-les par priorité, retrouvez-les facilement et assignez-les à de nouveaux projets ou tâches au moment opportun."
        img="idees.png"
        :imgLeft="true"
        :imgWidth="500"
      />
    </div>
  </section>

  <!-- Avantages PME -->
  <section class="py-16 bg-gray-50">
    <div class="max-w-4xl mx-auto">
      <h2 class="text-2xl font-bold mb-8 text-center">Pensé pour les PME</h2>
      <div class="grid md:grid-cols-2 gap-8">
        <div class="bg-white rounded-lg shadow p-6 flex flex-col items-center">
          <span class="text-3xl mb-2">👥</span>
          <h3 class="font-bold mb-2">Adapté aux entreprises de 1 à 25 personnes</h3>
          <p class="text-gray-600 text-center">Une solution flexible, que vous soyez indépendant ou une équipe en croissance.</p>
        </div>
        <div class="bg-white rounded-lg shadow p-6 flex flex-col items-center">
          <span class="text-3xl mb-2">🔔</span>
          <h3 class="font-bold mb-2">Rappels automatiques</h3>
          <p class="text-gray-600 text-center">Tous les membres reçoivent des notifications pour ne rien oublier.</p>
        </div>
        <div class="bg-white rounded-lg shadow p-6 flex flex-col items-center">
          <span class="text-3xl mb-2">✨</span>
          <h3 class="font-bold mb-2">Simple et intuitif</h3>
          <p class="text-gray-600 text-center">Conçu pour être utilisé sans formation, même pour les moins technophiles.</p>
        </div>
        <div class="bg-white rounded-lg shadow p-6 flex flex-col items-center">
          <span class="text-3xl mb-2">🚀</span>
          <h3 class="font-bold mb-2">Mises à jour continues</h3>
          <p class="text-gray-600 text-center">
            De nouvelles fonctionnalités régulièrement.<br>
            <router-link to="/blog" class="text-primary underline">Voir le blog</router-link>
          </p>
        </div>
        <div class="bg-white rounded-lg shadow p-6 flex flex-col items-center md:col-span-2">
          <span class="text-3xl mb-2">💡</span>
          <h3 class="font-bold mb-2">Vos demandes sont prises en compte</h3>
          <p class="text-gray-600 text-center">Nous écoutons nos utilisateurs pour faire évoluer l’outil selon vos besoins.</p>
        </div>
      </div>
      <div class="flex justify-center mt-10">
        <router-link to="/signup" class="bg-primary hover:bg-primary-dark text-white font-bold py-3 px-8 rounded shadow-lg transition">
          Essai gratuit 30 jours
        </router-link>
        <router-link to="/pricing" class="ml-4 bg-white text-primary font-bold py-3 px-8 rounded shadow-lg border border-primary hover:bg-primary hover:text-white transition">
          Voir les tarifs
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import HeroSection from '@/components/Showcase/HeroSection.vue';
import FeatureBlock from '@/components/Showcase/FeatureBlock.vue';

export default {
  name: 'ShowcaseFeatures',
  components: {
    HeroSection,
    FeatureBlock,
  },
};
</script>